export const CHUNK_LOADING_GLOBAL = '__CONTENT_RENDERER_LOADED_CHUNKS__';
